// removed by extract-text-webpack-plugin
module.exports = {"spinner":"spinner___3BMYq","rotation":"rotation___3Jd5Y","negative":"negative___3vUcZ","small":"small___1lGTv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Loading/Spinner/index.scss
// module id = 95
// module chunks = 0